/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDocumentTemplateCategoryDto } from '../../models/create-document-template-category-dto';
import { DocumentTemplateCategoryDto } from '../../models/document-template-category-dto';

export interface DocumentTemplateCategoryControllerCreateDocument$Params {
  centerId: string;
      body: CreateDocumentTemplateCategoryDto
}

export function documentTemplateCategoryControllerCreateDocument(http: HttpClient, rootUrl: string, params: DocumentTemplateCategoryControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, documentTemplateCategoryControllerCreateDocument.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentTemplateCategoryDto>;
    })
  );
}

documentTemplateCategoryControllerCreateDocument.PATH = '/api/document-template-category';
